module.exports = __webpack_public_path__ + "img/stable.5bb77bf6.svg";